import { NotificationGroup } from '@progress/kendo-react-notification';
import { LargeBanner } from 'app/components/LargeBanner';
import { useNotificationsContext } from 'context';
import * as React from 'react';

export const WelcomePopUp = () => {
  const anchor = React.useRef(null);

  const { screenCenteredNotifications } = useNotificationsContext();

  React.useEffect(() => {
    function handleClickOutside(event) {
      if (event.target.className === 'k-overlay') {
        event.stopPropagation();
        localStorage.setItem('justLoggedOn', 'false');
      }
    }

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  });

  return (
    <>
      {localStorage.getItem('justLoggedOn') === 'true' && <LargeBanner />}
      <NotificationGroup className="alert position" ref={anchor}>
        {screenCenteredNotifications?.map(({ notification }) => notification)}
      </NotificationGroup>
    </>
  );
};
